import { type ReactNode, Component } from 'react';

import ErrorPage from './ErrorPage';
import ErrorLogger from '@/services/logger/ErrorLogger';

interface ErrorBoundaryProps {
  children: ReactNode;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, { hasError: boolean; eventId?: string }> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, eventId: '' };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- default React typing
  componentDidCatch(error: Error, errorInfo: Record<string, any>) {
    const eventId = ErrorLogger.logCrash(error, errorInfo);

    console.log('Crash logged to Sentry #', eventId, error);
    this.setState({ eventId });
  }

  render() {
    if (this.state.hasError) return <ErrorPage eventId={this.state.eventId} />;

    return this.props.children;
  }
}

export default ErrorBoundary;
